import { BooleanCons, NumberCons, PaymentTypeInfo, StringConst } from 'src/app/constants/const';
import { Endpoints } from 'src/environments/endpoints';
import { PaymentInformation } from '../local/payment.model';
import { BaseResponseHttp } from './commons.model';
import { CreateBBVAOrder, PayInvoiceWithCard, PaypalInvoiceChangePayment } from './invoices-Pending';
import { CallPlace } from './myActivity.model';
import { ConfirmOrderReq } from './ordersresume.model';

export interface BBVACreateOrderResponse extends BaseResponseHttp {
    response: BBVATransactionData;
}

export class BBVATransactionData {
    transactionId: string;
    cardCode: string;
    bbvaOrderId: string;
    constructor() {
        this.transactionId = StringConst.empty;
        this.cardCode = StringConst.empty;
        this.bbvaOrderId = StringConst.empty;
    }
}

export class BBVAOpenPageData {
    amount: number;
    customerName: string;
    cardCode: string;
    callPlace: CallPlace;
    confirmOrder: ConfirmOrderReq;
    payInvoice: CreateBBVAOrder;
    default: BBVATransactionData;
    transactionId: string;
    successUrl: string;
    failureUrl: string;
    isCreateOrder: boolean;
    constructor() {
        this.amount = NumberCons.zero;
        this.customerName = StringConst.empty;
        this.cardCode = StringConst.empty;
        this.callPlace = CallPlace.default;
        this.confirmOrder = new ConfirmOrderReq();
        this.payInvoice = new CreateBBVAOrder();
        this.default = new BBVATransactionData();
        this.transactionId = StringConst.empty;
        this.successUrl = StringConst.empty;
        this.failureUrl = StringConst.empty;
        this.isCreateOrder = BooleanCons.false;
    }
}

export interface BBVAOrderDetailResponse {
    response: BBVAOrderDetail;
}
export class BBVAOrderDetail {
    paymentMethod: PaymentInformation;
    method: string;
    creationDate: Date;
    dueDate: Date;
    totalCost: number;
    iva: number;
    subtotal: number;
    hourLeftToExpire: number;
    costShipping: number;
    totalDiscount: number;
    isShippingCostAccepted: boolean;
    hasDiscountSpecial: boolean;
    percentDiscountSpecial: number;
    creditNoteAmount: number;
    discountSpecialAmount: number;
    totalProducts: number;
    totalPieces: number;
    promotionalCodeAmount: number;
    costShippingDiscount: number;
    constructor() {
        this.paymentMethod = new PaymentInformation();
        this.method = StringConst.empty;
        this.creationDate = new Date();
        this.dueDate = new Date();
        this.totalCost = NumberCons.zero;
        this.iva = NumberCons.zero;
        this.subtotal = NumberCons.zero;
        this.hourLeftToExpire = NumberCons.zero;
        this.costShipping = NumberCons.zero;
        this.totalDiscount = NumberCons.zero;
        this.isShippingCostAccepted = BooleanCons.false;
        this.hasDiscountSpecial = BooleanCons.false;
        this.percentDiscountSpecial = NumberCons.zero;
        this.creditNoteAmount = NumberCons.zero;
        this.discountSpecialAmount = NumberCons.zero;
        this.totalProducts = NumberCons.zero;
        this.totalPieces = NumberCons.zero;
        this.promotionalCodeAmount = NumberCons.zero;
        this.costShippingDiscount = NumberCons.zero;
    }
}
export interface BBVAOpenTransactionsResponse extends BaseResponseHttp {
    response: Array<IBBVAOpenTransactionData>;
}

export type TTransactionType = 'order' | 'orderChangePayment' | 'invoice' | 'invoiceChangePayment';

type TBBVAurl = {
    success: string;
    failure: string;
};

export const BBVAUrls: { [key in TTransactionType]: TBBVAurl } = {
    order: {
        success: Endpoints.bbva.successOrder,
        failure: Endpoints.bbva.failureOrder
    },
    orderChangePayment: {
        success: Endpoints.bbva.successChange,
        failure: Endpoints.bbva.failureChange
    },
    invoice: {
        success: Endpoints.bbva.successInvoice,
        failure: Endpoints.bbva.failureInvoice
    },
    invoiceChangePayment: {
        success: Endpoints.bbva.successChangeInvoice,
        failure: Endpoints.bbva.failureChangeInvoice
    }
};

export interface IBBVAOpenTransactionData {
    cardCode: string;
    amount: number;
    transactionId: string;
    transactionType: TTransactionType;
}

export interface ChangedMethodResponse extends BaseResponseHttp {
    response: ChangedMethod;
}

export class ChangedMethod {
    updatePaymentDetail: ChangedPrices;
    newPaymentMethod: PaymentTypeInfo;
    type: string;
    shopCart: ChangeMethodNewCart;
    constructor() {
        this.type = StringConst.empty;
        this.updatePaymentDetail = new ChangedPrices();
        this.newPaymentMethod = PaymentTypeInfo.default;
        this.shopCart = new ChangeMethodNewCart();
    }
}
export class ChangedPrices {
    transactionId: string;
    totalCost: number;
    iva: number;
    shippingCost: number;
    discountAmount: number;
    totalProducts: number;
    totalPieces: number;
    shippingCostAccepted: boolean;
    discountSpecial: number;
    creditNoteAmount: number;
    discountSpecialAmount: number;
    subtotal: number;
    promotionalCodeAmount: number;
    costShippingDiscount: number;
    constructor() {
        this.transactionId = StringConst.empty;
        this.totalCost = NumberCons.zero;
        this.iva = NumberCons.zero;
        this.shippingCost = NumberCons.zero;
        this.discountAmount = NumberCons.zero;
        this.totalProducts = NumberCons.zero;
        this.totalPieces = NumberCons.zero;
        this.shippingCostAccepted = BooleanCons.false;
        this.discountSpecial = NumberCons.zero;
        this.creditNoteAmount = NumberCons.zero;
        this.discountSpecialAmount = NumberCons.zero;
        this.subtotal = NumberCons.zero;
        this.promotionalCodeAmount = NumberCons.zero;
        this.costShippingDiscount = NumberCons.zero;
    }
}

export class ChangeMethodNewCart {
    totalProducts: number;
    totalPieces: number;
    constructor() {
        this.totalProducts = NumberCons.zero;
        this.totalPieces = NumberCons.zero;
    }
}
export interface TransactionDetailStatusResponse extends BaseResponseHttp {
    response: TransactionDetail[];
}
export enum TransactionStatus {
    active = 'Activo',
    received = 'Entregado',
    send = 'Enviado',
    pending = 'Pendiente'
}
export class TransactionDetail {
    status: TransactionStatus;
    constructor() {
        this.status = TransactionStatus.pending;
    }
}

export interface BBVAParamsResponse extends BaseResponseHttp {
    response: BBVAParams;
}

export class BBVAParams {
    promotions: string;
    promotionsMSI: string;
    expirationsDays: number;
    paymenthMethods: string;
    constructor() {
        this.promotions = StringConst.empty;
        this.promotionsMSI = StringConst.empty;
        this.expirationsDays = NumberCons.zero;
        this.paymenthMethods = StringConst.empty;
    }
}
export interface BBVACardsResponse extends BaseResponseHttp {
    response: BBVACard[];
}

export class BBVACard {
    id: number;
    cardCode: string;
    tokenId: string;
    holderName: string;
    lastDigits: string;
    constructor() {
        this.cardCode = StringConst.empty;
        this.tokenId = StringConst.empty;
        this.holderName = StringConst.empty;
        this.lastDigits = StringConst.empty;
        this.id = NumberCons.zero;
    }
}

export class DeleteCardReq {
    cardCode: string;
    cardId: string;
    constructor() {
        this.cardCode = StringConst.empty;
        this.cardId = StringConst.empty;
    }
}
